import { useState, useEffect, useCallback } from 'react'
import { supabase } from '../../supabase'
import { aujourdhui, formatLong } from '../../utils/planning'

const CODES = [
  { code: 'ACCUEIL', label: 'Accueil (standard)' },
  { code: 'ACCUEIL_MAJORE', label: 'Accueil majoré (férié, samedi sans Anne-Julie)' },
  { code: 'ASSISTANAT', label: 'Assistanat de cours' },
]

function euro(n) {
  return `${Number(n).toLocaleString('fr-FR')} €`
}

export default function TarifsJournees() {
  const [lignes, setLignes] = useState([])
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)
  const [msg, setMsg] = useState(null)
  const [form, setForm] = useState({ code: 'ACCUEIL', montant: '', date_effet: aujourdhui() })

  const charger = useCallback(async () => {
    setLoading(true)
    const { data, error } = await supabase.from('tarifs_journee').select('*').order('date_effet', { ascending: false })
    if (error) setMsg({ type: 'error', text: 'Impossible de charger les tarifs.' })
    setLignes(data || [])
    setLoading(false)
  }, [])

  useEffect(() => { charger() }, [charger])

  async function ajouter(e) {
    e.preventDefault()
    setMsg(null)
    const montant = parseFloat(form.montant)
    if (Number.isNaN(montant) || montant < 0) { setMsg({ type: 'error', text: 'Montant invalide.' }); return }
    setSaving(true)
    const { error } = await supabase.from('tarifs_journee')
      .upsert({ code: form.code, montant, date_effet: form.date_effet }, { onConflict: 'code,date_effet' })
    setSaving(false)
    if (error) { setMsg({ type: 'error', text: "Erreur lors de l'enregistrement." }); return }
    setMsg({ type: 'success', text: 'Tarif enregistré.' })
    setForm(f => ({ ...f, montant: '' }))
    charger()
  }

  async function supprimer(l) {
    if (!window.confirm(`Supprimer le tarif ${euro(l.montant)} du ${formatLong(l.date_effet)} ?`)) return
    const { error } = await supabase.from('tarifs_journee').delete().eq('code', l.code).eq('date_effet', l.date_effet)
    if (error) { setMsg({ type: 'error', text: 'Erreur lors de la suppression.' }); return }
    charger()
  }

  const aujourd = aujourdhui()

  return (
    <div>
      {msg && <div className={`alert alert-${msg.type}`}>{msg.text}</div>}

      <div className="card" style={{ marginBottom: 20 }}>
        <h3 style={{ marginBottom: 14 }}>Nouveau tarif</h3>
        <form onSubmit={ajouter}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '0 20px' }}>
            <div className="form-group">
              <label>Journée</label>
              <select value={form.code} onChange={e => setForm(f => ({ ...f, code: e.target.value }))}>
                {CODES.map(c => <option key={c.code} value={c.code}>{c.label}</option>)}
              </select>
            </div>
            <div className="form-group">
              <label>Montant (€)</label>
              <input type="number" min="0" step="0.01" value={form.montant} required
                onChange={e => setForm(f => ({ ...f, montant: e.target.value }))} />
            </div>
            <div className="form-group">
              <label>Applicable à partir du</label>
              <input type="date" value={form.date_effet} required
                onChange={e => setForm(f => ({ ...f, date_effet: e.target.value }))} />
            </div>
          </div>
          <button type="submit" className="btn btn-bordeaux" disabled={saving}>
            {saving ? 'Enregistrement...' : 'Enregistrer le tarif'}
          </button>
          <div className="text-muted" style={{ fontSize: 12, marginTop: 12 }}>
            Le montant s'applique aux journées saisies dont la date est égale ou postérieure à la date choisie.
            Les journées déjà enregistrées gardent leur montant.
          </div>
        </form>
      </div>

      {loading ? <div className="spinner" /> : CODES.map(c => {
        const hist = lignes.filter(l => l.code === c.code)
        const courant = hist.find(l => l.date_effet <= aujourd)
        return (
          <div className="card" key={c.code} style={{ marginBottom: 16 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: 10 }}>
              <h3>{c.label}</h3>
              <strong>{courant ? `${euro(courant.montant)} aujourd'hui` : 'Aucun tarif en vigueur'}</strong>
            </div>
            <table>
              <thead><tr><th>À partir du</th><th className="num">Montant</th><th></th></tr></thead>
              <tbody>
                {hist.length === 0 ? (
                  <tr><td colSpan={3} className="text-muted">Aucun tarif</td></tr>
                ) : hist.map(l => (
                  <tr key={l.date_effet} style={l === courant ? {} : { opacity: 0.7 }}>
                    <td>{formatLong(l.date_effet)}{l === courant && <span className="badge badge-actif" style={{ marginLeft: 8 }}>En vigueur</span>}</td>
                    <td className="num">{euro(l.montant)}</td>
                    <td style={{ textAlign: 'right' }}>
                      <button className="btn btn-outline btn-sm" onClick={() => supprimer(l)}>Supprimer</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )
      })}
    </div>
  )
}
